















import {Component, Prop, Vue} from "vue-property-decorator";
import {STreeData} from "@/components/dto/STreeData";
import XmlTreeItem from "@/components/XmlTreeItem.vue";
@Component({
  components: {XmlTreeItem}
})
export default class XmlTree extends Vue {
  @Prop() treeData!: STreeData;
  @Prop({default: false}) readonly!: boolean;

  created(){

  }


}
